import { createAction } from '@reduxjs/toolkit';

const REQUEST_SIZE = 'zola/cart/REQUEST_SIZE';
const RECEIVE_SIZE = 'zola/cart/RECEIVE_SIZE';

export const requestCartSizeAction = createAction(REQUEST_SIZE);
export const receivedCartSizeAction = createAction<number>(RECEIVE_SIZE);
